import styled from '@emotion/styled';
import { Text } from '@naf/text';
import { simbaStyled, colors } from '@naf-simba/theme';
import { IconButton } from '@naf-simba/elements-buttons';
import { TextList } from '@naf-simba/elements-textlist';

export const Container = simbaStyled('div')(({ theme }) => ({
  padding: theme.spacing('l'),
  backgroundColor: `${colors.secondary[50]}E6`,
  width: 'auto',
  borderRadius: theme.shape.borderRadiusScale.l,
  backdropFilter: 'blur(1px)',
  marginBottom: theme.spacing('xl'),
}));

export const Header = simbaStyled(Text)(({ theme }) => ({
  margin: 0,

  [`@media (max-width: ${theme.breakpoints.values.lg}px)`]: {
    fontSize: '1.25rem',
  },
}));

export const HeaderRow = simbaStyled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: theme.spacing('ml'),
  marginBottom: theme.spacing('ml'),
}));

export const FavoriteButton = styled(IconButton)`
  svg {
    font-size: 1.5rem;
  }
`;

// The item text is a Typography span with its own font styles, so `li` can't set them.
export const StyledCheckList = simbaStyled(TextList)(() => ({
  'li > span:not([aria-hidden])': {
    fontWeight: 700,
    fontSize: '1rem',
  },
}));
